"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSBlockType = exports.TSColors = void 0;
var TSColors;
(function (TSColors) {
    TSColors[TSColors["Red"] = 16711680] = "Red";
    TSColors[TSColors["Green"] = 65280] = "Green";
    TSColors[TSColors["Blue"] = 255] = "Blue";
    TSColors[TSColors["Yellow"] = 16776960] = "Yellow";
    TSColors[TSColors["Teal"] = 32896] = "Teal";
    TSColors[TSColors["Purple"] = 8388736] = "Purple";
    TSColors[TSColors["Gray"] = 8947848] = "Gray";
    TSColors[TSColors["LightGray"] = 13421772] = "LightGray";
    TSColors[TSColors["DarkGray"] = 4473924] = "DarkGray";
})(TSColors || (exports.TSColors = TSColors = {}));
class TSBlockType {
    constructor(color, char) {
        this.char = char;
        this.color = color;
    }
}
exports.TSBlockType = TSBlockType;
TSBlockType.Tree = new TSBlockType(0x0, 'T');
TSBlockType.Player = new TSBlockType(0x0, 'P');
TSBlockType.Entity = new TSBlockType(0x0, 'E');
